import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { transportTypeFormDefault } from "@factory/form/form.default";
import { TransportTypeFormRule, TransportTypeFormSchema } from "@factory/form/form.rule";
import { useQyCreateTransportType } from "@factory/query/transport-type.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewTransportType() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateTransportType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New TransportType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addTransportType, isLoading: isCreating } =
    useQyCreateTransportType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<TransportTypeFormSchema>({
    defaultValues: transportTypeFormDefault,
    resolver: zodResolver(TransportTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: TransportTypeFormSchema) => {
    const formData = mapCreateTransportType(form);
    addTransportType(formData);
  };
  const handleValidateError = (err: FieldErrors<TransportTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
